import { A as ListItem, C as Subscript, E as MathServerExtension, I as Hyperlink, J as listFootnotes, M as Indentation, Mt as textWordCount, P as Image, Q as Emoji, Rt as Audio, T as OrderedList, V as FootnoteStatic, X as FontMarks, Y as TaskList, Z as EmptyMediaNode, _ as Superscript, _t as BlockBackground, d as TextColor, et as Document, f as editorWordCount, ft as Code, gt as BlockTextVisibility, h as Table, ht as Blockquote, i as TrailingNode, j as LineSpacing, jt as getText, m as TaskItem, mt as List, n as CadmusEditorWrapper, o as Thread, ot as Collab, p as Telemetry, pt as BulletList, q as editorFootnoteWordCount, r as Video, t as makeCodeBlockDomSpec, vt as Blank, w as PasteChip, z as Highlight } from "./makeCodeBlockDomSpec-DVJpWLtZ.mjs";
import { Editor, Extension, Node, createDocument, getSchema } from "@tiptap/core";
import { Bold } from "@tiptap/extension-bold";
import { HardBreak } from "@tiptap/extension-hard-break";
import { Heading } from "@tiptap/extension-heading";
import { Italic } from "@tiptap/extension-italic";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Strike } from "@tiptap/extension-strike";
import { Text } from "@tiptap/extension-text";
import { TextAlign } from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import { Underline } from "@tiptap/extension-underline";
import { EditorState, Plugin } from "@tiptap/pm/state";
import { Step } from "@tiptap/pm/transform";
import { collab, getVersion, receiveTransaction, sendableSteps } from "@tiptap/pm/collab";
import { generateHTML } from "@tiptap/html";
//#region src/extensions/code-block-server/code-block-server.ts
/**
* `CodeBlock` node to be rendered on the server for html rendering, without
*  using `codemirror`, which does not build on the server.
*/
const CodeBlockServer = Node.create({
	name: "codeBlock",
	marks: "",
	code: true,
	content: "text*",
	addOptions() {
		return {
			HTMLAttributes: {},
			theme: "cadmus-light"
		};
	},
	addAttributes() {
		return {
			language: { default: "CSS" },
			theme: { default: "cadmus-light" },
			lineNumbersVisible: { default: true },
			languageVisible: { default: true }
		};
	},
	parseHTML() {
		return [{
			tag: "pre",
			preserveWhitespace: "full"
		}];
	},
	renderHTML({ node }) {
		return makeCodeBlockDomSpec(node.textContent, node.attrs.language, node.attrs.theme, node.attrs.lineNumbersVisible, node.attrs.languageVisible);
	}
});
//#endregion
//#region src/extensions/cadmus-kit/cadmus-kit-server.ts
const CadmusKitServer = Extension.create({
	name: "cadmusKit",
	addProseMirrorPlugins() {
		return [new Plugin({ props: { attributes: () => {
			return {
				role: "textbox",
				"aria-multiline": "true",
				translate: "no",
				id: `cadmus-${this.options.editorId}`
			};
		} } })];
	},
	addExtensions() {
		const { enableBlanks = false, enableImage = true, enableAudio = true, enableVideo = true, enableHyperlink = true, enableFontControls = false } = this.options;
		return [
			Document,
			Heading.configure({ levels: [
				1,
				2,
				3,
				4
			] }),
			HardBreak,
			Paragraph,
			Blockquote,
			Bold,
			Italic,
			Strike,
			Text,
			MathServerExtension,
			Table,
			List,
			Emoji,
			EmptyMediaNode.configure({ nodeNames: [
				...enableImage ? ["image"] : [],
				...enableAudio ? ["audio"] : [],
				...enableVideo ? ["video"] : []
			] }),
			ListItem,
			BulletList,
			OrderedList,
			...enableHyperlink ? [Hyperlink] : [],
			this.options.enableHangingIndent ? Indentation.configure({
				specialTypes: ["paragraph"],
				levelTypes: [],
				indentationStyles: ["hanging"],
				defaultIndentation: "hanging"
			}) : Indentation,
			FootnoteStatic,
			Thread,
			Superscript,
			Subscript,
			TextAlign.configure({ types: [
				"paragraph",
				"heading",
				"image"
			] }),
			Underline,
			Highlight,
			TextStyle,
			TextColor,
			...enableFontControls ? [FontMarks, LineSpacing] : [],
			TaskItem,
			TaskList,
			...enableBlanks ? [Blank] : [],
			PasteChip,
			...enableImage ? [Image] : [],
			...enableAudio ? [Audio] : [],
			...enableVideo ? [Video] : [],
			TrailingNode,
			BlockTextVisibility.configure({ types: ["tableCaption", "tableFootnote"] }),
			BlockBackground.configure({ types: [
				"table",
				"tableCell",
				"tableHeader"
			] }),
			CodeBlockServer,
			Code,
			Collab.configure({
				version: this.options.version,
				clientId: this.options.clientId
			}),
			Telemetry.configure({ editorId: this.options.editorId })
		];
	}
});
//#endregion
export { CadmusEditorWrapper, CadmusKitServer, Editor, EditorState, Step, collab, textWordCount as countWords, textWordCount, createDocument, editorFootnoteWordCount, editorWordCount, generateHTML, getSchema, getText, getVersion, listFootnotes, receiveTransaction, sendableSteps };

//# sourceMappingURL=server.mjs.map